// extracted by mini-css-extract-plugin
export var compactFilters = "_d0-4";
export var detailImage = "_d0-1";
export var dropdownContainer = "_d0-2";
export var imageContainer = "_d0-0";
export var selectedCard = "_d0-3";